
import React from 'react';
import { Row, Col, Image } from "antd";
import { currencyFormat, idNamingConversion, capitalizeFirstLetter } from "../../../../../../helpers/utilities";
import customStyles from "../../../../../../assets/styles/customStyles";
import { Typography, TextField, InputAdornment } from "@mui/material";
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import clsx from 'clsx';
import { NavLink } from "react-router-dom";
import AddIcon from "../../../../../../assets/images/icon_actions/Add Icon.svg";
import DeleteIcon from "../../../../../../assets/images/icon_actions/Delete Icon.svg";


export const MixedPayments = React.forwardRef((props, ref) => {
    const { form, headerView, customObject, mopDetails, handActivePaymentMethod, parameterDetails,
        mixedPayments, handleAddPayment, changeHandlerPayment, deletePaymentMethod, resetPayments,
        changeHandler, handleActiveInputs, roundOffAmount, discountAmount, error } = props;
    const classes = customStyles();

    return (
        <>
            <Row>
                <Col span={24} className={classes.mixedPaymentHeader}>
                    <Row gutter={20}>
                        <Col span={8}>
                            Tot. Amnt. Due <span className={classes.bold}>{'₹ ' + currencyFormat(parseFloat(parseFloat(form?.invoiceAmount || 0).toFixed(2)))}</span>
                        </Col>
                        <Col span={8}>
                            Amnt. Recd. <span className={classes.bold}>{'₹ ' + (currencyFormat(parseFloat(parseFloat(form?.amountReceived || 0).toFixed(2))))}</span>
                        </Col>
                        <Col span={8}>
                            Balance Due <span className={classes.bold}>{'₹ ' + (form?.amountReceived ? currencyFormat(parseFloat(parseFloat(form?.invoiceAmount || 0).toFixed(2)) - parseFloat(parseFloat(form?.amountReceived || 0).toFixed(2))) : currencyFormat(0))}</span>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row gutter={20} className={clsx(classes.storeInvoiceAmountPayment, classes.margin20t)}>
                <Col span={8}>
                    <div className={clsx(classes.storeInvoiceAmount, classes.storeAmountReceived, classes.eqStoreHeight, classes.storeInvoiceRoundOffAmount, classes.textAlignRight,)}>
                        {
                            headerView ? <>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Round Off</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                    {capitalizeFirstLetter(form?.roundOffMethod || 'BLANK')} - ₹ {currencyFormat(form?.roundOffAmount || 0)}</Typography>
                            </> : <Row>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <h4>Round Off <span className={classes.shortKey}>(Alt + R)</span></h4>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={clsx(classes.removeUnderline)}>
                                    <AutoCompleteComponent
                                        name={[""]}
                                        heads={[{ 'key': 'name', 'name': 'Name' }]}
                                        details={[{ id: '', name: 'Blank' }, { id: 'UP', name: 'Up' }, { id: 'DOWN', name: 'Down' }]}
                                        parentValue={customObject([{ id: '', name: 'Blank' }, { id: 'UP', name: 'Up' }, { id: 'DOWN', name: 'Down' }], form?.roundOffMethod)}
                                        onChange={(data) => { changeHandler(data?.id, 'roundOffMethod'); resetPayments(); }}
                                        position={"bottom"}
                                        //setRef={(ref) => { roundOffMethodRef = ref }}
                                        id={idNamingConversion('roundOffMethod', 'storeSales', 'DropDown')}
                                    />
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                    <TextField autoComplete='one-time-code'
                                        label={[""]}
                                        fullWidth
                                        type="number"
                                        error={error?.roundOffAmount && true}
                                        helperText={error?.roundOffAmount}
                                        variant={'standard'}
                                        name="roundOffAmount"
                                        value={form.roundOffAmount}
                                        inputRef={roundOffAmount}
                                        InputProps={{
                                            classes: {
                                                input: clsx(classes.textFieldColor, classes.padding10L)
                                            },
                                        }}
                                        inputProps={{
                                            step: "any",
                                        }}
                                        id={idNamingConversion('roundOffAmount', 'storeSales', 'TextField')}
                                        onFocus={(e) => handleActiveInputs(e.target.name)}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom
                                        }}
                                        disabled={form?.roundOffMethod ? false : true}
                                        onChange={(e) => {
                                            changeHandler(e); resetPayments()
                                        }}
                                        className={clsx(classes.removeUnderline)}
                                    />
                                </Col>
                            </Row>
                        }
                    </div>
                    <div className={clsx(classes.storeInvoiceAmount, classes.storeAmountReceived, classes.eqStoreHeight, classes.textAlignRight, classes.margin20t)}>
                        <h4>Bill Discount <span className={classes.shortKey}>(Alt + B)</span></h4>
                        {
                            headerView ? <p>{'₹ ' + (currencyFormat(form?.discountAmount || 0))}</p> : <TextField autoComplete='one-time-code'
                                className={clsx(classes.removeUnderline)}
                                label={''}
                                variant={'standard'}
                                name={"discountAmount"}
                                type={'number'}
                                inputRef={discountAmount}
                                value={form?.discountAmount || ''}
                                fullWidth
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">₹ </InputAdornment>,
                                    classes: {
                                        input: clsx(classes.textFieldColor, classes.textAlignRight, classes.amountReceived)
                                    },
                                }}
                                id={idNamingConversion('Bill Discount', 'storeSales', 'TextField')}
                                onWheel={(e) => e.target.blur()}
                                disabled={form?.salesType === 'Sale Return' ? true : false}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onFocus={(e) => handleActiveInputs(e.target.name)}
                                onChange={(e) => {
                                    if (form?.salesType !== 'Sale Return') {
                                        changeHandler(e.target.value, 'discountAmount');
                                        resetPayments();
                                    }
                                }}
                            />
                        }
                    </div>
                </Col>
                <Col span={16} style={{ height: 132, overflow: "auto" }} id="paymentDiv">
                    {
                        mixedPayments?.map((pay, i) => (
                            <Row key={i} gutter={20} className={clsx({ [classes.margin20t]: i !== 0 })}>
                                <Col span={12}>
                                    <div className={clsx(classes.storeInvoiceAmount, classes.storeAmountReceived, classes.eqStoreHeight, classes.textAlignRight)}>
                                        <h4>Amount</h4>
                                        {
                                            headerView ? <p>{'₹ ' + (currencyFormat(pay?.amount || 0))}</p> : <TextField autoComplete='one-time-code'
                                                className={clsx(classes.removeUnderline)}
                                                label={''}
                                                variant={'standard'}
                                                name={"amount"}
                                                type={'number'}
                                                value={pay?.amount || ''}
                                                fullWidth
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start">₹ </InputAdornment>,
                                                    classes: {
                                                        input: clsx(classes.textFieldColor, classes.textAlignRight, classes.amountReceived)
                                                    },
                                                }}
                                                id={idNamingConversion('Amount', 'storeSalesPayment', 'TextField')}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.keyCode === 40 || e.keyCode === 38) {
                                                        e.preventDefault();
                                                        return false
                                                    }
                                                }}
                                                onFocus={(e) => { handleActiveInputs(e.target.name); handActivePaymentMethod(i); }}
                                                onWheel={(e) => e.target.blur()}
                                                disabled={form?.salesType === 'Sale Return' ? true : false}
                                                onChange={(e) => {
                                                    if (e.target.value === '' || parseFloat(e.target.value) <= parseFloat(pay?.originalAmount)) {
                                                        changeHandlerPayment(parseFloat(e.target.value), 'amount', i);
                                                    } else {
                                                        changeHandlerPayment(parseFloat(pay?.originalAmount), 'amount', i);
                                                    }
                                                }}
                                            />
                                        }
                                    </div>
                                </Col>
                                <Col span={12}>
                                    {
                                        headerView ?
                                            <div className={clsx(classes.storeInvoiceAmount, classes.storeAmountReceived, classes.eqStoreHeight, classes.textAlignRight)}>
                                                <h4>Payment Method <span className={classes.shortKey}></span></h4>
                                                <p>{pay?.mop?.method || '---'}</p>
                                            </div>
                                            : <div className={classes.positionRelative}>
                                                <AutoCompleteComponent
                                                    customLabel={`Payment Method ${(i + 1)}`}
                                                    heads={[{ 'key': 'method', 'name': 'Name' }]}
                                                    details={parameterDetails?.mopIds && parameterDetails?.mopIds?.length > 0 ? mopDetails.filter(item => parameterDetails?.mopIds.includes(item.id)) : mopDetails}
                                                    parentValue={customObject(mopDetails, pay?.mopId)}
                                                    position={"bottom"}
                                                    variant={'outlined'}
                                                    notEmpty={true}
                                                    onChange={(data) => changeHandlerPayment(data, 'mopId', i, 'mop')}
                                                    parentError={error?.mopId}
                                                />
                                                <img alt={'delete'} onClick={() => deletePaymentMethod(i)} src={DeleteIcon} className={classes.payDeleteIcon} />
                                            </div>
                                    }
                                </Col>
                            </Row>
                        ))
                    }
                </Col>
                {
                    !headerView && <Col span={24} className={classes.textAlignRight}>
                        {
                            (!form?.amountReceived || parseFloat(form?.invoiceAmount - form?.amountReceived) > 0) ?
                                <NavLink
                                    to={'#'}
                                    id={idNamingConversion('Add', 'storeSalesPaymnet', 'Link')}
                                    onClick={() => handleAddPayment()}
                                    className={clsx(classes.customLink, classes.margin20t)}>
                                    <Image src={AddIcon} preview={false} className={clsx(classes.antImage)} />
                                    <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add</span>
                                </NavLink> : <NavLink
                                    to={'#'}
                                    id={idNamingConversion('Add', 'storeSalesPaymnet', 'Link')}
                                    disabled={true}
                                    className={clsx(classes.customLink, classes.margin20t)}>
                                    <Image src={AddIcon} preview={false} className={clsx(classes.antImage)} />
                                    <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add</span>
                                </NavLink>
                        }
                    </Col>
                }
            </Row>
        </>
    )
})